<template>
  <div class="concept">
    <div id="head-page" class="contact parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/cloud.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.3"><img class="" src="@/assets/images/head/echelle.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/papillon.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

   <div class="grid-container content-page">
      <div class="grid-x grid-container-padding">
        <div class="small-12 medium-8 medium-offset-2  large-6 large-offset-3 cell center">
         <title-page attrpage="" baseline="Une remarque ou une idée ?">Suggestion</title-page>

         <p>Donnez nous le plus de précisions possible par rapport à votre expérience afin de nous aider (<em>Version du navigateur, action effectué, etc.)</em></p>
         <p v-if="thx">Merci pour votre retour !</p>
         <div class="form date" v-else>
           <div class="line">
              <div :class="{error: errors.indexOf('choice') !== -1}">
                <label for="titreRdv">Vous avez * :</label>
                <select v-model="choice">
                  <option value="suggestion">Une suggestion</option>
                  <option value="erreur">Une erreur</option>
                  <option value="other">Autres</option>
                </select>
              </div>

              <div :class="{error: errors.indexOf('name_page') !== -1}">
                <label for="titreRdv">Indiquez la page en question :
                </br><em> exemple : accueil, carnet de bord, concept, etc.</em></label>
                <input type="text" name="titreRdv" id="titreRdv" required v-model="name_page" />
              </div>

              <label for="comment">Votre commentaire :</label>
              <textarea id="comment" name="comment" v-model="comment"></textarea>

              <input class="button btnPush" name="submit" type="submit" value="Valider" @mouseover="verify" @click="send"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import TitlePage from '@/components/TitlePage'
  export default {
    components: { TitlePage },
    data () {
      return {
        choice: '',
        name_page: '',
        comment: '',
        errors: [],
        thx: false
      }
    },
    methods: {
      ...mapActions(['sendSuggestion']),
      verify (field) {
        this.errors = []
        if (!this.choice) {
          this.errors.push("choice")
        }
        if (!this.name_page) {
          this.errors.push("name_page")
        }
      },
      async send (e) {
        e.preventDefault();
        this.verify();
        if (this.errors.length > 0) {
          return false
        }

        try {
          this.sendSuggestion({type: this.choice, page: this.name_page, message: this.comment})
          this.thx = true;
        } catch(ex) {
          throw ex;
        }
      }
    },
  }
</script>
